<template>
  <section class="endpoint-root">
    <div class="container">
      <div class="endpoint-root__heading">
        <div class="endpoint-name">
          <input type="text" v-model="formName" @change="syncRename" />
          <ui-icon name="edit" />
        </div>
      </div>
      <ui-tabs :items="tabs" v-model="activeTab" v-if="isActive" />
      <div class="endpoint-root__content" v-if="isActive">
        <endpoint-settings
          v-if="activeTab === 'Settings'"
          :settings="settingsList"
        />
        <endpoint-integration
          v-if="activeTab === 'Integration'"
          :cdn="cdn"
          :api-path="apiPath"
          @edit-form="activeTab = 'Form Builder'"
        />
        <form-code
          v-if="activeTab === 'Form Code'"
          :endpoint="endpoint"
          :api-path="apiPath"
        />
        <plugins-root v-if="activeTab === 'Plugins'" />
        <email-presets
          :endpoint="endpoint"
          v-if="activeTab === 'Email Templates'"
        />
      </div>
      <div class="endpoint-root__content" v-else>
        <messages-root :endpoint="endpoint" />
      </div>
    </div>
  </section>
</template>

<script>
import API from '../../../api'

import {
  setRouterParams,
  getRouterParams
} from '../../../services/local-router'

import UiTabs from '../ui-kit/ui-tabs.vue'
import UiComponentLoader from '../ui-kit/ui-component-loader.vue'
import UiHeader from '../ui-kit/ui-header.vue'
import UiIcon from '../ui-kit/ui-icon.vue'

export default {
  components: {
    UiTabs,
    UiIcon,
    EndpointIntegration: () => ({
      component: import('./endpoint-integration.vue'),
      loading: UiComponentLoader
    }),
    FormCode: () => ({
      component: import('../form-code/form-code.vue'),
      loading: UiComponentLoader
    }),
    MessagesRoot: () => ({
      component: import('../messages/messages-root.vue'),
      loading: UiComponentLoader
    }),
    EndpointSettings: () => ({
      component: import('./endpoint-settings.vue'),
      loading: UiComponentLoader
    }),
    PluginsRoot: () => ({
      component: import('../plugins/plugins-root.vue'),
      loading: UiComponentLoader
    }),
    EmailPresets: () => ({
      component: import('../email-builder/email-presets.vue'),
      loading: UiComponentLoader
    }),
    UiHeader
  },
  name: 'endpoint-root',
  props: {
    cdn: String,
    apiPath: String,
    endpoint: {
      type: Object,
      required: true
    },
    settingsList: Array
  },
  data() {
    return {
      tabs: [
        'Integration',
        'Form Code',
        'Plugins',
        'Settings',
        'Email Templates'
      ],
      activeTab: 'Integration',
      activePlugin: undefined,
      formName: this.endpoint.form_name
    }
  },
  computed: {
    isActive() {
      return this.endpoint.archive !== 1
    }
  },
  async created() {
    this.$store.commit('setEndpoint', this.endpoint)

    const localRouterParams = getRouterParams()
    if (localRouterParams) {
      if (localRouterParams.current) {
        this.activeTab = localRouterParams.current
      }
      if (localRouterParams.plugin) {
        this.activePlugin = localRouterParams.plugin
      }
    }
  },
  methods: {
    async syncRename() {
      await API.forms.update({
        endpointId: this.endpoint.id,
        projectId: this.endpoint.project_id,
        payload: {
          form_name: this.formName
        }
      })
    }
  },
  watch: {
    activeTab() {
      setRouterParams({ current: this.activeTab, plugin: this.activePlugin })
    }
  }
}
</script>

<style lang="scss">
.endpoint-root {
  padding: 80px 0;
  &__heading {
    margin-bottom: 40px;
  }
  &__content {
    padding: 1.5rem;
    background: $white;
    border-radius: $border-radius;
    box-shadow: 0 4px 16px rgba(#000, 0.08);
  }
}
.endpoint-name {
  position: relative;

  input {
    display: block;
    width: 100%;
    padding: 8px 16px 8px 48px;
    font-weight: bold;
    font-size: 24px;
    line-height: normal;
    background-color: transparent;
    border: 0;
    border-radius: $border-radius-sm;
    outline: none;
    box-shadow: 0 0 0 2px transparent;
    cursor: pointer;
    transition: 0.2s;
    &:hover {
      box-shadow: 0 0 0 2px $gray-400;
    }
    &:focus {
      box-shadow: 0 0 0 2px $blue;
    }
  }
  .ui-icon {
    position: absolute;
    top: 50%;
    left: 0.5em;
    z-index: 1;
    color: $gray-500;
    font-size: 24px;
    transform: translateY(-50%);
    pointer-events: none;
  }
}
</style>
